import { createApp } from 'vue';
import App from './App.vue';
import router from './router';  // 导入路由

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
app.use(ElementPlus)
createApp(App)
  .use(router)  // 使用 Vue Router
  .mount('#app');
